import React from 'react';
import { Box, Card, CardHeader, CardContent, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableFooter, TablePagination, TableRow, Typography, } from '@mui/material';
import { defineMessages, useIntl } from 'react-intl';
import { useQuery } from 'react-query';
import { Map, GoogleMapProvider, useGoogleMap } from '../map/google';
import API from '@wheeebo/polaris-api';
import { CircleLoader, LoadError } from '../loader';
const INITIAL_ITEM_COUNT = 5;
const msgs = defineMessages({
    cellDate: {
        id: 'pages.member.mission.FlightPathCard.cell.date',
        defaultMessage: 'Date',
    },
    cellDuration: {
        id: 'pages.member.mission.FlightPathCard.cell.duration',
        defaultMessage: 'Duration',
    },
    headerTitle: {
        id: 'pages.member.vehicle.FlightLogCard.header.title',
        defaultMessage: 'Flight Logs',
    },
    headerSubTitle: {
        id: 'pages.member.vehicle.FlightLogCard.header.subTitle',
        defaultMessage: 'Past flight records of this vehicle',
    },
});
function SessionMap({ apiKey, session }) {
    const { setBounds } = useGoogleMap();
    React.useEffect(() => {
        setTimeout(() => {
            if (session.path) {
                setBounds?.(session.path?.map((e) => ({ lat: e.lat, lng: e.lng })));
            }
        }, 500);
    }, [session.path, setBounds]);
    return React.createElement(Map, { apiKey: apiKey, paths: session.path ? [session.path] : undefined, locked: true, hideAllUIs: true, highlightPath: true });
}
function Row({ apiKey, session, selected, onSelect }) {
    const intl = useIntl();
    const durationSeconds = (session.updatedAt - session.createdAt) / 1000;
    return (React.createElement(TableRow, { hover: true, onClick: () => onSelect?.(session), sx: {
            cursor: onSelect ? 'pointer' : undefined,
            backgroundColor: selected ? 'action.selected' : undefined,
            '&:hover': selected ? { backgroundColor: 'action.selected' } : undefined,
        } },
        React.createElement(TableCell, { sx: { pb: 3 } },
            React.createElement(Stack, { direction: "row", gap: 1, sx: { justifyContent: 'space-between', alignItems: 'center' } },
                React.createElement(Typography, { variant: "body2" }, intl.formatDate(session.createdAt, { dateStyle: 'short', timeStyle: 'short' })),
                React.createElement(Typography, { variant: "body2" }, intl.formatNumber(Math.floor(durationSeconds > 60 ? durationSeconds / 60 : durationSeconds), {
                    style: 'unit',
                    unitDisplay: 'long',
                    unit: durationSeconds > 60 ? 'minute' : 'second',
                }))),
            React.createElement(Box, { sx: { width: '100%', minHeight: 180, position: 'relative' } },
                React.createElement(GoogleMapProvider, null,
                    React.createElement(SessionMap, { apiKey: apiKey, session: session }))))));
}
function FlightLogCard({ apiKey, vehicleId, selectedSessionId, onSessionSelected }) {
    const intl = useIntl();
    const [page, setPage] = React.useState(0);
    const options = {
        limit: INITIAL_ITEM_COUNT,
        offset: page * INITIAL_ITEM_COUNT,
        vehicleId,
    };
    const { data, isError, isLoading } = useQuery(API.Sessions.listKey(options), () => API.Sessions.list(options));
    return (React.createElement(Card, null,
        React.createElement(CardHeader, { title: intl.formatMessage(msgs.headerTitle), subheader: intl.formatMessage(msgs.headerSubTitle) }),
        React.createElement(CardContent, null,
            React.createElement(Stack, { gap: 1 },
                isLoading ? React.createElement(CircleLoader, null) : null,
                isError ? React.createElement(LoadError, null) : null,
                data && data.total > 0 ? (React.createElement(TableContainer, { component: Paper, elevation: 0 },
                    React.createElement(Table, null,
                        React.createElement(TableBody, null, data.items?.map((e) => (React.createElement(Row, { key: e.id, apiKey: apiKey, session: e, selected: selectedSessionId === e.id, onSelect: onSessionSelected })))),
                        React.createElement(TableFooter, null,
                            React.createElement(TableRow, null,
                                React.createElement(TablePagination, { sx: {
                                        '.MuiTablePagination-displayedRows': { m: 1 },
                                    }, backIconButtonProps: { sx: { p: 0 } }, nextIconButtonProps: { sx: { p: 0 } }, rowsPerPageOptions: [INITIAL_ITEM_COUNT], count: data?.total || 0, rowsPerPage: INITIAL_ITEM_COUNT, page: page, SelectProps: {
                                        inputProps: { 'aria-label': 'rows per page' },
                                    }, onPageChange: (_, newPage) => setPage(newPage) })))))) : (React.createElement(Typography, { variant: "body2" }, "No record found."))))));
}
export default React.memo(FlightLogCard);
